<template>
    <ul>
        <li class="form-label">
            {{ $t('Enable preview timeout') }}
        </li>
        <li>
            <cic-checkbox
                id="profile_previewTimeout"
                :enabled="editing"
                :value="previewTimeoutEnabled"
                @input="(val) => updateFieldValue('previewTimeoutAction', val ? 'accept' : '')"
            />
        </li>
        <template v-if="previewTimeoutEnabled">
            <li class="form-label">
                {{ $t('Preview timeout action') }}
            </li>
            <li>
                <CicRadioGroup
                    id="profile_timeoutAction"
                    :enabled="editing"
                    :value="item.previewTimeoutAction"
                    :options="[
                        { value: 'accept', label: $t('Accept call') },
                        { value: 'reject', label: $t('Reject call') },
                    ]"
                    @input="(val) => updateFieldValue('previewTimeoutAction', val)"
                />
            </li>
            <li class="form-label">
                {{ $t('Default preview duration') }}
            </li>
            <li>
                <edit-duration
                    id="profile_previewDuration"
                    :enabled="editing"
                    :value="item.previewDuration"
                    @input="(val) => updateFieldValue('previewDuration', val)"
                />
            </li>
            <li class="form-label">
                {{ $t('Enable extend preview') }}
            </li>
            <li>
                <cic-checkbox
                    id="profile_previewExtend"
                    :enabled="editing"
                    :value="item.previewExtend"
                    @input="(val) => updateFieldValue('previewExtend', val)"
                />
            </li>
            <template v-if="item.previewExtend">
                <li class="form-label">
                    {{ $t('Preview extension duration') }}
                </li>
                <li>
                    <edit-duration
                        id="profile_previewExtendDuration"
                        :enabled="editing"
                        :value="item.previewExtendDuration"
                        @input="(val) => updateFieldValue('previewExtendDuration', val)"
                    />
                </li>
                <li class="form-label">
                    {{ $t('Maximum preview duration') }}
                </li>
                <li>
                    <edit-duration
                        id="profile_previewMaxDuration"
                        :enabled="editing"
                        :value="item.previewMaxDuration"
                        @input="(val) => updateFieldValue('previewMaxDuration', val)"
                    />
                </li>
            </template>
        </template>
    </ul>
</template>

<script>
    import CicCheckbox from '@/components/inputs/CicCheckbox';
    import CicRadioGroup from '@/components/inputs/CicRadioGroup';
    import EditDuration from './EditDuration';

    export default {
        name: 'EditPreview',
        components: {
            CicCheckbox,
            CicRadioGroup,
            EditDuration,
        },
        props: {
            editing: {
                type: Boolean,
                default: false,
            },
            item: {
                type: Object,
                required: true,
            },
        },
        emits: ['input'],
        computed: {
            previewTimeoutEnabled() {
                return ['accept', 'reject'].includes(this.item.previewTimeoutAction);
            },
        },
        methods: {
            updateFieldValue(field, val) {
                this.$emit('input', field, val);
            },
        },
    };
</script>
